import React from 'react';

import { Nav, NavItem, NavLink} from 'reactstrap';

export default class Navy extends React.Component {
  render() {
    return (
      <div className="container">
      <br/><br/><br/>
        <Nav className="fixed-top">
          
            <NavLink href="https://briskcleaningservice.com" ><img src="./images/briskLogo.png" alt='logo' className="img-fluid" id="logo"/></NavLink>
            <NavItem>Brisk Cleaning Service</NavItem>
          
        </Nav>
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/Navy.js